export const authHeader = () => {
    let auth = JSON.parse(sessionStorage.getItem('loginInfo'));
 
    if (auth && auth.token) {
        return { 'Authorization': 'Bearer ' + auth.token };
    } else {
        return {};
    }
}
